import React from 'react';
import fetch from '../fetch';

import utils from '../../utils';

import {Modal, message, Popover} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'orgName', label: '部门名称', width: 150},
    {key:'employeeCode', label: '职工代码'},
    {key:'realName', label: '职工名称'},
    {key:'categoryName', label: '授权分类名称',render: (value,row) =>
    <span> 
        <Popover placement="topLeft" style={{ width: 300 }}  content={
            <div style={{ width: 200 }}>
                {
                    row.categoryPathStr
                }
            </div>} 
            title="分类路径"
            >
            {value}
        </Popover>
    </span> 
    },
    {key:'userTypeName', label: '授权类型'}
    
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('supv/authorize/list',  Object.assign({}, keywords))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method insert
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('supv/authorize/insert', data)
    .then(response => {
        if(response.code === 200) {
            message.success('温馨提示：添加成功！');
        }
    });
}

const insertByType= (data) => {
    return fetch.post('supv/authorize/insertByType', data)
    .then(response => {
        if(response.code === 200) {
            message.success('温馨提示：添加成功！');
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('supv/authorize/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
 const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove({ids: DataGrid.selections.join(',')})
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                                callback();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
 }
 
/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

export default {
    querySearch,
    insert,
    insertByType,
    remove,
    columns,
    onSelect,
    batchRemove,
    getSelection,
    setRefresh,
}